import React from 'react';
import { SuggestedDateProps } from './SuggestedDate.props';
import { classes, StyledButton } from './SuggestedDate.styles';



const SuggestedDate = ({ suggestedDate, handleClickSuggested }: SuggestedDateProps) => (
  <StyledButton className={classes.suggestedDate} onClick={() => handleClickSuggested(suggestedDate)}>
    <small>Suggested: {suggestedDate}</small>
  </StyledButton>
);

export default SuggestedDate;
